if(jQuery(".products-slider").length) {
    jQuery("#carousel_product__header .products-slider").slick({
        infinite: true,
        swipe: true,
        dots: true,
        dotsClass: "slick-dots hero-slider__dots",
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        slidesToShow: 1,
        speed: 1
    });
}
